import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=7d6886be&scoped=true&"
var script = {}
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=7d6886be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6886be",
  null
  
)

export default component.exports